'use strict';
//global


import {EventEmitter} from '../utils';


const eventEmitter = new EventEmitter();

let initialized = false;
let scrolledTop  = 0;
let scrolledLeft = 0;




function _scrollPositionTop() {
  let position = (window.pageYOffset || window.document.scrollTop) - (window.document.clientTop || 0);
  if (isNaN(position)) position = 0;
  return position;
}
function _scrollPositionLeft() {
  let position = (window.pageXOffset || window.document.scrollLeft) - (window.document.clientLeft || 0);
  if (isNaN(position)) position = 0;
  return position;
}

function _change() {
  scrolledTop  = _scrollPositionTop();
  scrolledLeft = _scrollPositionLeft();

  eventEmitter.dispatch(_getData('change'));
}


function _getData(type) {
  return {
    type: type,
    _module: 'scroll.store',
    top:  scrolledTop,
    left: scrolledLeft
  }
}



function _init() {
  scrolledTop  = _scrollPositionTop();
  scrolledLeft = _scrollPositionLeft();

  window.addEventListener('scroll', _change, false);

  initialized = true;
}





if (!initialized) _init();

export default {
  eventEmitter: eventEmitter,
  getData: _getData.bind(null, undefined)
};
